exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-body-test {\r\n  /*margin: 0 20px 60px;*/\r\n  margin-bottom: 60px;\r\n  padding: 20px;\r\n  background-color: white;\r\n}\r\n\r\n.block {\r\n  margin-bottom: 10px;\r\n}\r\n\r\ntextarea:-moz-read-only {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\ntextarea:read-only {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.quest-separate {\r\n  border: none; /* Убираем границу для браузера Firefox */\r\n  color: #222222; /* Цвет линии для остальных браузеров */\r\n  background-color: #222222; /* Цвет линии для браузера Firefox и Opera */\r\n  height: 1px; /* Толщина линии */\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/translate/translate-questions/translate-questions.component.css
// module id = ../../../../../src/app/content-page/translate/translate-questions/translate-questions.component.css
// module chunks = main